
import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { useDispatch, useSelector} from 'react-redux';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { delete_appointment, get_byDate, get_byPatient } from 'http/components/AppointmentService';
import { SetAppointmentsData, SetPatientAppointmentsData } from 'Utils/Helpers/HandleApiData';
import { TextShow } from 'Utils/Helpers/TextShow';
import GetAppointmentType from 'Utils/Helpers/AppointmentType';
import GetAppointmentStatus from 'Utils/Helpers/AppointmentStatus';
import ActionButton from 'Utils/Helpers/ActionButton';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppointmentDelete({ data, patient }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [semi, setSemi] = useState(false);
  const { dateSearch, current } = useSelector((state) => ({
    dateSearch: state.setting.dateSearch,
    current: state.staff.current,
  }));
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }
  const onEnter = () => {
    setSemi(false);
  }
  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const response = await delete_appointment(data.id);
    if(response.status) {
      if(patient) {
        const response2 = await get_byPatient(patient);
        if(response2.status) {
          await dispatch(SetPatientAppointmentsData(response2.data))
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        const response2 = await get_byDate(dateSearch.date);
        if(response2.status) {
            await dispatch(SetAppointmentsData(response2.data))
        } else {
          dispatch(HandleLoading(false));
        }
      }
    } else {
      dispatch(HandleLoading(false));
    }
    setShow(false);
  }
  return (
    <>
      <ActionButton
        icon={<icons.Trash3/>}
        onClick={setShowDialog}
        disabled={!current[1][4]}
        hidden={!current[1][4]}
      />
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          TransitionProps={{onEnter: onEnter}}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className='delete-mode'>
            {`حذف نوبت`}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            {
              (show && !semi) ?
              <DialogContentText id="alert-dialog-slide-appointment-edit">
                <div className='delete-body'>
                  <div className='content'>
                    <p>
                      {'از حذف نوبت با مشخصات زیر اطمینان دارید ؟'}
                    </p>
                    <div className='details'>
                      <TextShow
                        title={"تاریخ نوبت :"}
                        data={data.date}
                        className2={'fw-bold'}
                      />
                      <TextShow
                        title={"نوع نوبت :"}
                        data={<GetAppointmentType id={data.type} />}
                      />
                      <TextShow
                        title={"وضعیت :"}
                        data={<GetAppointmentStatus id={data.lastStatus}/>}
                      />
                    </div>
                    <small className='text-danger'>
                      {`با حذف این نوبت تمامی وضعیت های ثبت شده برای آن نیز حذف خواهد گردید (بدون امکان بازیابی)`}
                    </small>
                  </div>
                </div>
              </DialogContentText> : <p className='mb-1'>
                {"آیا از حذف مطمئن هستید ؟"}
              </p>
            }
          </DialogContent>
          <DialogActions>
            {
              semi
              ? <div className='w-100 flex-row-center-center'>
                <CButton
                  text={'خیر'}
                  icon={<icons.XLg/>}
                  onClick={handleClose}
                  action=''
                  className={'ms-2'}
                />
                <CButton
                  text={'بله'}
                  icon={<icons.Trash3/>}
                  onClick={onFinish}
                  action='delete'
                />
              </div>
              : <CButton
                text={'حذف نوبت'}
                icon={<icons.Trash3/>}
                onClick={() => setSemi(true)}
                action='delete'
              />
            }
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
